import React from 'react';
import DeliverabilityOps from '@/components/app/DeliverabilityOps';

export default function Deliverability() {
  return <DeliverabilityOps />;
}
